export function hasChangesAvailability(oldAvailability, newAvailability) {
  // Проверка булевого значения
  if (oldAvailability.availableInAllCountries !== newAvailability.availableInAllCountries) {
    console.log('change boolean');
    return true;
  }

  // Проверка массивов allowedCountriesIds
  const oldAllowed = new Set(oldAvailability.allowedCountriesIds.map(Number));
  const newAllowed = new Set(newAvailability.allowedCountriesIds.map(Number));

  if (
    [...newAllowed].some((id) => !oldAllowed.has(id)) || // Есть добавленные элементы
    [...oldAllowed].some((id) => !newAllowed.has(id)) // Есть удаленные элементы
  ) {
    console.log('change allow', newAllowed, oldAllowed);
    return true;
  }

  const oldDisallowed = new Set(oldAvailability.disallowedCountriesIds.map(Number));
  const newDisallowed = new Set(newAvailability.disallowedCountriesIds.map(Number));

  if (
    [...newDisallowed].some((id) => !oldDisallowed.has(id)) || // Есть добавленные элементы
    [...oldDisallowed].some((id) => !newDisallowed.has(id)) // Есть удаленные элементы
  ) {
    console.log('change disallow');
    return true;
  }

  return false;
}
